 <!--page starts-->
    <section class="page-wrapper">
      <div class="ashton-hero-top-clubsponsorship" [ngStyle]="{'background-image':'url(' + contactInfo?.data?.image + ')'}">
      	<div class="ashton-hero-top-contact-bg-color"></div>
      	<div class="container">
      	   <div class="ashton-hero-top-clubsponsorship-detail">
      	   	    <div class="ashton-hero-top-contact-left" >
	      	   	   <h2>Contact / Info</h2>
	      	   	   <h3>{{contactInfo?.data?.title}}</h3>
	      	   	   <h4>{{contactInfo?.data?.subtitle}}</h4>
	      	   	   <p>{{contactInfo?.data?.address}}</p>
	      	   	   <p>Office Tel:<a href="tel:{{contactInfo?.data?.phone_no}}"> {{contactInfo?.data?.phone_no}} </a>&nbsp;| Social Club:<a href="#"> {{contactInfo?.data?.social_club}}</a></p>
	      	   	   <p><span><img src="assets/images/email.svg"></span><a href="mailto:{{contactInfo?.data?.email}}">{{contactInfo?.data?.email}}</a></p>
	      	   	</div>
	      	   	<div class="ashton-hero-top-contact-right">
					<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2373.1795474802075!2d-2.0813018841556996!3d53.50098798001175!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x487bb635241e496b%3A0xe116f043bdd5b5d!2sAshton%20United%20Football%20Club!5e0!3m2!1sen!2sin!4v1630675653094!5m2!1sen!2sin" width="500" height="324" frameborder="0" style="border:0;" allowfullscreen="" aria-hidden="false" tabindex="0"></iframe>
	      	   		<!--<iframe src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d3776843.676506548!2d71.31966105!3d22.4168315!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sen!2sin!4v1604745611438!5m2!1sen!2sin" width="500" height="324" frameborder="0" style="border:0;" allowfullscreen="" aria-hidden="false" tabindex="0"></iframe>-->
	      	   	</div>
      	   </div> 	
      	</div>
      	<div class="overlay"></div>
      	
      </div>
      <div class="ashton-hero-top-clubsponsorship-section cf">
      	 <div class="container">
      	 	<div class="ashton-hero-top-clubsponsorship-section-detail cf">
      	 		<div class="ashton-clubsponsorship-bottom">
      	 			<div class="ashton-clubsponsorship-box" *ngFor="let general of contactInfogeneral?.data?.contactinfo_general">
                                    <div class="ashton-clubsponsorship-box-img">
                                    	<img [src]="general?.image">
                                    </div>
                                    <div class="ashton-clubsponsorship-box-content">
                                    	<div class="ashton-clubsponsorship-box-content-left">
                                    		<h2>{{general?.title}}</h2>
                                    		<p [innerHTML]="general?.description"></p>	
                                    	</div>
                                    </div>
                              </div>
                              <!-- <div class="ashton-clubsponsorship-box">
                                    <div class="ashton-clubsponsorship-box-img">
                                    	<img src="assets/images/02.png">
                                    </div>
                                    <div class="ashton-clubsponsorship-box-content">
                                    	<div class="ashton-clubsponsorship-box-content-left">
                                    		<h2>Admission Prices</h2>
                                    		<p>10 – Adults<br>£6 – Concessions (Over 65 & students with ID)<br>Accompanied children under 12 will be £1<br>Note all under 12’s must be accompanied by an adult.  </p>
                                    	</div>
                                    </div>
                              </div> -->
      	 		</div>
      	 	</div>
      	 	<div class="ashton-hero-top-contact-content">
      	 		<p [innerHTML]="contactInfogeneral?.data?.contactinfo_other[0]?.description"></p>
      	 	</div>
      	 	<div class="ashton-hero-top-contact-incorporated cf">
      	 		<div class="red-titel">{{contactInfogeneral?.data?.contactinfo_other[0]?.title}}</div>
      	 		<div class="ashton-hero-top-contact-incorporated-detail cf">
      	 			<div class="ashton-hero-top-contact-incorporated-box">
      	 				<div class="ashton-hero-top-contact-incorporated-content">
      	 					<h3>Jonathan Burke</h3>
      	 					<p>Co-Chairman</p>
      	 				</div>
      	 				<div class="ashton-hero-top-contact-incorporated-image">
      	 					<img src="assets/images/jonathan_burke.png">
      	 				</div> 
                        <div class="ashton-player-overlay">
                            <img src="assets/images/red-shadow-ic.png" alt="red-shadow-ic">
                        </div>
      	 			</div>
      	 			<div class="ashton-hero-top-contact-incorporated-box">
      	 				<div class="ashton-hero-top-contact-incorporated-content">
      	 					<h3>David Burke</h3>
      	 					<p>Co-Chairman</p>
      	 				</div>
      	 				<div class="ashton-hero-top-contact-incorporated-image">
      	 					<img src="assets/images/david_burke.png">
      	 				</div> 
                        <div class="ashton-player-overlay">
                            <img src="assets/images/red-shadow-ic.png" alt="red-shadow-ic">
                        </div>
      	 			</div>
      	 			<!--<div class="ashton-hero-top-contact-incorporated-box">
      	 				<div class="ashton-hero-top-contact-incorporated-content">
      	 					<h3>Jonathan Burke</h3>
      	 					<p>Co-Chairman</p>
      	 				</div>
      	 				<div class="ashton-hero-top-contact-incorporated-image">
      	 					<img src="assets/images/pl.png">
      	 				</div> 
                        <div class="ashton-player-overlay">
                            <img src="assets/images/red-shadow-ic.png" alt="red-shadow-ic">
                        </div>
      	 			</div>
      	 			<div class="ashton-hero-top-contact-incorporated-box">
      	 				<div class="ashton-hero-top-contact-incorporated-content">
      	 					<h3>Jonathan Burke</h3>
      	 					<p>Co-Chairman</p>
      	 				</div>
      	 				<div class="ashton-hero-top-contact-incorporated-image">
      	 					<img src="assets/images/pl.png">
      	 				</div> 
                        <div class="ashton-player-overlay">
                            <img src="assets/images/red-shadow-ic.png" alt="red-shadow-ic">
                        </div>
      	 			</div>-->
      	 		</div>
      	 	</div>
      	 	<div class="ashton-hero-top-contact-covid cf">
      	 		<div class="red-titel">{{contactInfogeneral?.data?.contactinfo_other[0]?.title2}}</div>
      	 		<div class="ashton-hero-top-contact-covid-detail cf">
      	 			<div class="ashton-hero-top-contact-covid-left">
      	 				<div class="ashton-hero-top-contact-covid-image">
      	 					<img [src]="contactInfogeneral?.data?.contactinfo_other[0]?.image">
      	 				</div>
      	 			</div>
      	 			<div class="ashton-hero-top-contact-covid-right">
      	 				<ul>
      	 					<li *ngFor="let file of contactInfogeneral?.data?.contactinfo_other[0]?.contactinfoother_files"><a href="{{file?.files}}" download target="_blank">{{file?.title}}</a></li>
      	 					<!-- <li><a href="#">Ashton-United-Ground-Operating-Guidance-COVID-19-V5</a></li>
      	 					<li><a href="#">Ashton-United-Covid-19-Risk-V7-Final</a></li> -->
      	 				</ul>
      	 			</div>
      	 		</div>
      	 	</div>
      	 </div>
      </div>
    </section><!-- page ends -->